import { CloseIcon } from 'components/icons/CloseIcon';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import api from 'services/api';

interface IChannelMember {
  channelId: string;
}

const ChannelMember = ({ channelId }: IChannelMember) => {
  const [currentChannelMembers, setCurrentChannelMembers] = useState([]);
  const [searchVal, setSearchVal] = useState('');

  useEffect(() => {
    let isMount = true;
    api.get(`/api/users/channel/${channelId}/members/?sortBy=asc&page_size=25&page=1`).then((res) => {
      if (isMount) {
        setCurrentChannelMembers(res.data.results);
      }
    });

    return () => {
      isMount = false;
    };
  }, []);

  return (
    <div className="transparent font-lato">
      <div className="relative border bg-gray-bg-dark border-gray-300 rounded-lg bg-white pb-7 pt-9 px-7 w-screen md:w-[622px] md:max-h-[508px]">
        <div className="flex">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Members</span>
          <CloseIcon className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100" />
        </div>
        <input
          type="text"
          className="px-4 py-2 w-full mb-4 text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6 mt-8"
          placeholder="Search for a member"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSearchVal(e.target.value);
          }}
        />
        <div className="overflow-auto max-h-28">
          {currentChannelMembers
            .filter((item: any) =>
              (item.member.first_name + item.member.last_name + item.member.username)
                .toLowerCase()
                .includes(searchVal.toLowerCase())
            )
            .sort((a: any, b: any) => {
              if (
                a.member.username.toLowerCase().indexOf(searchVal?.toLowerCase()) <
                b.member.username.toLowerCase().indexOf(searchVal?.toLowerCase())
              ) {
                return -1;
              }
              if (
                a.member.username.toLowerCase().indexOf(searchVal?.toLowerCase()) >
                b.member.username.toLowerCase().indexOf(searchVal?.toLowerCase())
              ) {
                return 1;
              }
              return 0;
            })
            .map((channelMember: any, index: number) => (
              <div className="flex items-center" key={uuid()}>
                <input
                  type="checkbox"
                  id={`channelMember-checkbox-${index}`}
                  className="focus:ring-0"
                  value={channelMember.id}
                  name={channelMember.name}
                />
                <label
                  htmlFor={`channelMember-checkbox-${index}`}
                  className="text-base text-[#212529] font-normal font-lato pl-2"
                >
                  {channelMember.member.first_name + ' ' + channelMember.member.last_name}
                </label>
              </div>
            ))}
        </div>
        <div className="flex mt-5">
          <div className="h-11 cursor-pointer text-black text-base font-bold flex items-center justify-center">
            Add people
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChannelMember;
